app.directive('tabmenu', function () {
    return {
        restrict: 'E',
        transclude: true,
        replace: true,
        templateUrl: _pb + 'notifications/tabs.html',
        link: function (scope) {

        }
    };
});